export default __webpack_public_path__ + "static/media/1847.4826286f.png";